<template>
    <div>
        <div class="d-sm-block d-mb-block d-lg-none" v-if="isMobile">
            <v-overlay :value="visible" :absolute="false" opacity="1" scroll-strategy="block" class="overlay-mobile">
                <div class="main-container-mobile">
                    <!-- <img src="@/assets/img/top-left-bg.png" alt="Background" class="background-image-mobile-topleft" />
                    <img src="@/assets/img/top-right-bg.png" alt="Background"
                        class="background-image-mobile-topright" />
                    <img src="@/assets/img/bot-left-bg.png" alt="Background" class="background-image-mobile-botleft" />
                    <img src="@/assets/img/bot-right-bg.png" alt="Background"
                        class="background-image-mobile-botright" /> -->
                    <!-- <img src="@/assets/img/age-confirmation-bg.jpg" alt="Background" class="background-image-mobile" /> -->
                    <!-- <img src="@/assets/img/jameson-logo-age-confirm.jpg" alt="Background" class="background-image-mobile" /> -->
                    <div class="foreground-container-mobile">
                        <div class="age-mobile-topbar">
                            <nav class="age-lang-nav" aria-label="Тіл таңдау / Выбор языка">
                                <a href="#" :class="{ active: currentLang === 'ru' }" @click.prevent="onSelectLang('ru')">RU</a>
                                <a href="#" :class="{ active: currentLang === 'kz' }" @click.prevent="onSelectLang('kz')">KZ</a>
                            </nav>
                        </div>
                        <div class="first-block-mobile">
                            <img src="@/assets/img/jameson-logo-age-confirm.png" alt=""
                                class="jameson-logo-age-confirm-mobile" />
                            <h4 class="title-text-mobile">{{ txt.titleMobileLine1 }}
                                <span class="title-line-2">{{ txt.titleMobileLine2 }}</span>
                            </h4>
                            <div class="date-input-container-mobile">
                                <input type="text" maxlength="2" :placeholder="txt.day" @input="validateDay" v-model="day"
                                    class="date-input-mobile" />
                                <input type="text" maxlength="2" :placeholder="txt.month" @input="validateMonth" v-model="month"
                                    class="date-input-mobile" />
                                <input type="text" maxlength="4" :placeholder="txt.year" @input="validateYear" v-model="year"
                                    class="date-input-mobile" />
                            </div>
                            <button @click="confirmRegistration"
                                class="btn-confirm-mobile mt-10 mb-10">{{ txt.confirm }}</button>
                        </div>
                        <div class="second-block-mobile">
                            <img src="@/assets/img/jameson-bottle-age-mobile.png" alt=""
                                class="jameson-age-confirm-mobile mb-4" />

                        </div>
                    </div>
                </div>
            </v-overlay>
        </div>
        <div class="d-none d-lg-block d-xl-block d-xxl-block" v-else>
            <v-overlay :value="visible" :absolute="false" opacity="1" scroll-strategy="block" class="overlay-desktop">
                <div class="main-container">
                    <div class="age-desktop-topbar">
                        <nav class="age-lang-nav" aria-label="Тіл таңдау / Выбор языка">
                            <a href="#" :class="{ active: currentLang === 'ru' }" @click.prevent="onSelectLang('ru')">RU</a>
                            <a href="#" :class="{ active: currentLang === 'kz' }" @click.prevent="onSelectLang('kz')">KZ</a>
                        </nav>
                    </div>
                    <img src="@/assets/img/social-lead-first-bg.jpg" alt="Background" class="background-image" />
                    <div class="foreground-container">
                        <div class="first-block">
                            <img src="@/assets/img/jameson-logo-age-confirm.png" alt=""
                                class="jameson-logo-age-confirm" />
                            <h4 class="title-text">{{ txt.title }}</h4>
                            <div class="date-input-container">
                                <input type="text" maxlength="2" :placeholder="txt.day" @input="validateDay" v-model="day"
                                    class="date-input" />
                                <input type="text" maxlength="2" :placeholder="txt.month" @input="validateMonth" v-model="month"
                                    class="date-input" />
                                <input type="text" maxlength="4" :placeholder="txt.year" @input="validateYear" v-model="year"
                                    class="date-input" />
                            </div>
                            <button @click="confirmRegistration" class="btn-confirm mt-10 mb-10">{{ txt.confirm }}</button>
                        </div>
                        <div class="second-block">
                            <img src="@/assets/img/jameson-age-confirm.png" alt="" class="jameson-age-confirm" />

                        </div>
                    </div>
                </div>
            </v-overlay>
        </div>
        <v-snackbar v-model="snackbar" timeout="3000" class="btn-contaiener">
            {{ message }}
            <template v-slot:action="{ attrs }">
                <div class="snackbar-btn" text v-bind="attrs" @click="snackbar = false">
                    {{ txt.close }}
                </div>
            </template>
        </v-snackbar>
    </div>
</template>

<style scoped>
::v-deep .v-overlay__scrim {
    opacity: 1;
    /* background-color: #007749 !important;
    border-color: #007749 !important; */
    background-image: url('../assets/img/social-lead-first-bg.jpg');
    background-size: cover;
    background-position: center;
}



::v-deep .overlay-mobile,
.overlay-mobile {
    align-items: flex-start !important;
    justify-content: flex-start !important;
}

.overlay-mobile ::v-deep .v-overlay__content {
    position: relative;
    width: 100vw;
    max-width: 100%;
    height: 100%;
    max-height: 100dvh;
    max-height: -webkit-fill-available;
    max-height: 100vh;
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    transform: none !important;
}

.background-image-mobile-botright {
    position: absolute;
    bottom: -1px;
    right: 0;
    height: auto;
    /* width: 100%; */
    object-fit: cover;
    z-index: 1;
}

.background-image-mobile-botleft {
    position: absolute;
    bottom: -1px;
    left: 0;
    height: auto;
    /* width: 100%; */
    object-fit: cover;
    z-index: 1;

}

.background-image-mobile-topright {
    position: absolute;
    top: -1px;
    right: 0;
    height: auto;
    /* width: 100%; */
    object-fit: cover;
    z-index: 1;
}

.background-image-mobile-topleft {
    position: absolute;
    top: -1px;
    left: 0;
    height: auto;
    /* width: 100%; */
    object-fit: cover;
    z-index: 1;
}

/* .background-image-mobile {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    -o-object-fit: cover;
    object-fit: cover;
    z-index: 1;
} */

.foreground-container-mobile {
    display: flex;
    flex-direction: column;
    position: relative;
    z-index: 1000;
    color: #000;
    font-size: 24px;
    width: 100%;
    min-height: 100%;
    min-height: 100dvh;
    min-height: -webkit-fill-available;
    height: auto;
    justify-content: flex-start;
    align-items: center;
    box-sizing: border-box;
}

.btn-confirm,
.btn-confirm-mobile {
    border-radius: 10px;
    padding: 11px 42px;
    height: 59px;
    color: #007749;
    font-family: "JJ", "Oswald", "OswaldBold", "Montserrat", "Helvetica Neue", -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif;
    font-weight: 700;
    font-size: 19px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    background: #f1e4b2;
    cursor: pointer;
    transition: all 0.3s ease;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

/* При наведении */
.btn-confirm:hover,
.btn-confirm-mobile:hover {
    background: #f5f5f5;
    /* лёгкое затемнение белого */
    transform: translateY(-2px);
    box-shadow: 0 6px 0 #bcbcbc;

    /* ускоренный вход */
    transition: all 0.15s ease-out;
}

/* При нажатии */
.btn-confirm:active,
.btn-confirm-mobile:active {
    background: #e6e6e6;
    /* чуть темнее для нажатия */
    transform: translateY(2px);
    box-shadow: 0 2px 0 #9e9e9e;
    transition: all 0.1s ease-in;
}

.title-text-mobile {
    margin-bottom: 0px;
    font-family: "JJ", "Oswald", "OswaldBold", "Montserrat", "Helvetica Neue", -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif;
    color: #F1E4B2;
    font-size: 26px;
    line-height: 1.25;
    letter-spacing: 0.04em;
    text-align: center;
    font-weight: 700;
    margin-top: 33px;
    text-transform: uppercase;
}

.title-text-mobile .title-line-2,
.title-text-mobile pre {
    display: block;
    margin-top: 4px;
    margin-bottom: 0px;
    font-family: "JJ", "Oswald", "OswaldBold", "Montserrat", "Helvetica Neue", -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif;
    color: #F1E4B2;
    font-size: 24px;
    line-height: 1.25;
    letter-spacing: 0.04em;
    text-align: center;
    font-weight: 700;
}

.first-block-mobile {
    width: 100%;
    padding-top: 6px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.main-container-mobile {
    background-size: cover;
    background-position: center;
    position: relative;
    min-height: 100%;
    min-height: 100dvh;
    min-height: -webkit-fill-available;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    padding: 0;
    margin: 0;
}

.date-input {
    width: 115px;
    height: 55px;
    border: 2px solid #F1E4B2;
    border-radius: 10px;
    background-color: transparent;
    text-align: center;
    font-family: "Montserrat", "HelveticaNeueCyr", "Segoe UI", Roboto, Arial, sans-serif;
    font-weight: 700;
    font-size: 20px;
    color: #F1E4B2;
    outline: none;
}

.date-input::placeholder {
    color: white;
    opacity: 1;
}

.date-input:focus {
    border-color: red;
}

.date-input-mobile::placeholder {
    color: #F1E4B2;
    opacity: 1;
}

.date-input-mobile:focus {
    border-color: red;
}

.date-input-container-mobile {
    display: flex;
    flex-direction: column;
    gap: 25px;
    margin-bottom: 20px;
    justify-content: center;
    margin-top: 33px;
    text-align: center;
    align-items: center;
}

.date-input-mobile {
    width: 325px;
    height: 55px;
    border: 2px solid #F1E4B2;
    border-radius: 10px;
    background-color: transparent;
    text-align: center;
    font-family: "Montserrat", "HelveticaNeueCyr", "Segoe UI", Roboto, Arial, sans-serif;
    font-weight: 700;
    font-size: 20px;
    color: #F1E4B2;
    outline: none;
}


.second-block-mobile {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-top: 10px;
    padding-bottom: max(16px, env(safe-area-inset-bottom, 16px));
}

.jameson-age-confirm-mobile {
    max-width: min(320px, 80vw);
    width: auto;
    height: auto;
    margin-left: auto;
    margin-right: auto;
    display: block;
    object-fit: contain;
}

.second-block {
    display: flex;
    justify-content: center;
    align-items: center;
}

.jameson-age-confirm {
    max-width: 520px;
    width: 100%;
    height: auto;
    display: block;
    object-fit: contain;
    margin: 0 auto;
}

.jameson-logo-age-confirm-mobile {
    max-width: min(260px, 75vw);
    width: 100%;
    height: auto;
    object-fit: contain;
    margin: 0 auto;
    display: block;
}

/* Убираем стрелочки */
.date-input::-webkit-inner-spin-button,
.date-input::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.date-input {
    -moz-appearance: textfield;
    /* Для Firefox */
}

.date-input-container {
    display: flex;
    gap: 10px;
    /* Расстояние между полями */
    margin-bottom: 20px;
    justify-content: center;
    margin-top: 33px;
}

.date-input {
    width: 115px;
    height: 55px;
    border: 2px solid #f1e4b2;
    border-radius: 10px;
    background-color: transparent;
    text-align: center;
    font-family: var(--font-family);
    font-weight: 700;
    font-size: 20px;
    color: #f1e4b2;
    outline: none;
}

.date-input::placeholder {
    color: #f1e4b2;
    opacity: 1;
}

.date-input:focus {
    border-color: red;
}

.btn-confirm {
    border-radius: 10px;
    padding: 11px 42px;
    width: 231px;
    height: 59px;
    font-family: "JJ", "Oswald", "OswaldBold", "Montserrat", "Helvetica Neue", -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif;
    font-weight: 700;
    font-size: 19px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #007749;
    background: #f1e4b2;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.first-block {
    text-align: center;
}

.title-text {
    margin-bottom: 0px;
    font-family: "JJ", "Oswald", "OswaldBold", "Montserrat", "Helvetica Neue", -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif;
    font-weight: 700;
    font-size: 32px;
    line-height: 1.2;
    letter-spacing: 0.04em;
    color: #f1e4b2;
    margin-top: 50px;
    text-align: center;
    text-transform: uppercase;
}


.main-container {
    position: relative;
    /* Родительский контейнер для абсолютного позиционирования */
    height: 100vh;
    /* Высота на весь экран */
    width: 100vw;
    /* Ширина на весь экран */
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    /* Убираем прокрутку */
}

.background-image {
    position: absolute;
    /* Абсолютное позиционирование */
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    object-fit: cover;
    /* Пропорциональное сжатие */
    z-index: 1;
    /* Отправляем изображение на задний план */
}

.foreground-container {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 1000;
    color: #000;
    font-size: 24px;
    gap: 48px;
}

.snackbar-btn {
    color: #F1E4B2;
    font-family: "Montserrat", "Segoe UI", Roboto, Arial, sans-serif;
    font-size: 0.95rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    margin-right: auto;
    padding: 14px 16px;
    text-align: initial;
    cursor: pointer;
}

/* @media (orientation: landscape) {
    .foreground-container-mobile {
        height: auto;
    }
} */

.age-mobile-topbar {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    padding: 14px 20px 8px;
    padding-top: max(14px, calc(env(safe-area-inset-top, 0px) + 14px));
    padding-right: max(20px, calc(env(safe-area-inset-right, 0px) + 20px));
    padding-left: max(20px, calc(env(safe-area-inset-left, 0px) + 20px));
    padding-bottom: 8px;
    box-sizing: border-box;
    position: relative;
    z-index: 1005;
    flex-shrink: 0;
}

.age-desktop-topbar {
    position: absolute;
    top: 24px;
    top: max(24px, calc(env(safe-area-inset-top, 0px) + 24px));
    right: 32px;
    right: max(32px, calc(env(safe-area-inset-right, 0px) + 32px));
    z-index: 1005;
}

.age-lang-nav {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    background: rgba(0, 48, 38, 0.6);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border: 1px solid rgba(241, 228, 178, 0.3);
    border-radius: 999px;
    padding: 3px 5px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
    flex-shrink: 0;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
}

.age-lang-nav a {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 5px 12px;
    min-width: 40px;
    height: 30px;
    line-height: 1;
    font-family: "JJ", "Oswald", "Montserrat", "Segoe UI", Arial, sans-serif;
    font-weight: 700;
    font-size: 13px;
    letter-spacing: 0.08em;
    text-decoration: none;
    color: rgba(242, 228, 181, 0.75);
    border-radius: 999px;
    transition: background-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
    box-sizing: border-box;
    -webkit-tap-highlight-color: transparent;
    user-select: none;
    -webkit-user-select: none;
}

.age-lang-nav a.active {
    color: #00483A;
    background: #F1E4B2;
    font-weight: 800;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.age-lang-nav a:hover:not(.active) {
    color: #F1E4B2;
    background: rgba(241, 228, 178, 0.18);
}

</style>

<script>
import { mapActions } from "vuex";
import { trackAgeGate } from "@/utils/analytics";

export default {
    name: "ConfirmAge1",
    props: {
        lang: {
            type: String,
            default: "ru"
        }
    },
    watch: {
        lang(newVal) {
            if (newVal) this.localLang = newVal;
        }
    },
    data() {
        return {
            isMobile: window.innerWidth < 1264,
            day: "",
            month: "",
            year: "",
            snackbar: false,
            message: "",
            visible: true,
            localLang: this.lang || "ru",
        };
    },
    methods: {
        onSelectLang(l) {
            this.localLang = l;
            this.$emit('lang-change', l);
        },


        ...mapActions(['saveUserAge']),


        handleResize() {
            this.isMobile = window.innerWidth < 1264;
        },
        validateDay() {
            // Убираем все символы, кроме цифр, и ограничиваем длину до 2 символов
            this.day = this.day.replace(/\D/g, "").slice(0, 2);

            // Проверяем, что значение не превышает 31
            if (this.day > 31) {
                this.day = ""; // Очищаем поле, если значение некорректно
                this.snackbar = true;
                this.message = this.txt.errDay;
            }
        },
        validateMonth() {
            // Убираем все символы, кроме цифр, и ограничиваем длину до 2 символов
            this.month = this.month.replace(/\D/g, "").slice(0, 2);

            // Проверяем, что значение не превышает 12
            if (this.month > 12) {
                this.month = ""; // Очищаем поле, если значение некорректно
                this.snackbar = true;
                this.message = this.txt.errMonth;
            }
        },
        validateYear() {
            // Убираем все символы, кроме цифр, и ограничиваем длину до 4 символов
            this.year = this.year.replace(/\D/g, "").slice(0, 4);
        },
        confirmRegistration() {
            let isValid = true;

            // Проверяем корректность дня
            if (this.day.length !== 2 || this.day > 31 || this.day < 1) {
                this.day = ""; // Очищаем поле
                this.snackbar = true;
                this.message = this.txt.errDay;
                isValid = false;
            }

            // Проверяем корректность месяца
            if (this.month.length !== 2 || this.month > 12 || this.month < 1) {
                this.month = ""; // Очищаем поле
                this.snackbar = true;
                this.message = this.txt.errMonth;
                isValid = false;
            }

            // Проверяем корректность года
            if (this.year.length !== 4 || this.year < 1900 || this.year > new Date().getFullYear()) {
                this.year = ""; // Очищаем поле
                this.snackbar = true;
                this.message = this.txt.errYear;
                isValid = false;
            }

            // Если есть некорректные поля, прекращаем выполнение
            if (!isValid) {
                return;
            }

            // Проверяем, что дата корректна
            const today = new Date();
            const birthDate = new Date(this.year, this.month - 1, this.day);

            if (
                birthDate.getDate() != this.day ||
                birthDate.getMonth() + 1 != this.month ||
                birthDate.getFullYear() != this.year
            ) {
                this.snackbar = true;
                this.message = this.txt.errDate;
                return;
            }

            // Проверяем возраст
            const age = today.getFullYear() - birthDate.getFullYear();
            const monthDiff = today.getMonth() - birthDate.getMonth();
            const dayDiff = today.getDate() - birthDate.getDate();

            if (age > 21 || (age === 21 && (monthDiff > 0 || (monthDiff === 0 && dayDiff >= 0)))) {
                console.log(`Дата рождения: ${this.day}.${this.month}.${this.year}`);
                const userAge = `${this.year}-${this.month}-${this.day}`; // строка вида "дд.мм.гггг"


                // console.log("Итоговые данные:", userAge);
                // this.snackbar = true;

                // this.message = "Добро пожаловать!";
                this.saveUserAge(userAge);
                trackAgeGate(true);
                this.$emit("confirmed");
                this.visible = false;
                document.body.style.overflow = "";
                // Сохраняем в Vuex
                // this.$router.push('/jameson'); // Переход на следующую страницу
            } else {
                trackAgeGate(false);
                this.snackbar = true;
                this.message = this.txt.errAge;
                return;
            }

            // Собираем данные в переменную userAge

        },


    },
    beforeDestroy() {
        document.body.style.overflow = ""
        
        window.removeEventListener('resize', this.handleResize);
    },
    mounted() {
        document.body.style.overflow = "hidden"
        
        window.addEventListener('resize', this.handleResize);

    },
            computed: {
        currentLang() {
            return (this.localLang || this.lang || "ru").toLowerCase();
        },
        txt() {
            const isKz = this.currentLang === "kz";
            return {
                title: isKz ? "Туған күніңізді енгізіңіз" : "Введите дату рождения",
                titleMobileLine1: isKz ? "Туған күніңізді" : "Введите дату",
                titleMobileLine2: isKz ? "енгізіңіз" : "рождения",
                day: isKz ? "кк" : "дд",
                month: isKz ? "аа" : "мм",
                year: isKz ? "жжжж" : "гггг",
                confirm: isKz ? "Растаймын" : "Подтверждаю",
                close: isKz ? "Жабу" : "Закрыть",
                errDay: isKz ? "Күнді дұрыс енгізіңіз (01-31)." : "Пожалуйста, введите корректный день (01-31).",
                errMonth: isKz ? "Айды дұрыс енгізіңіз (01-12)." : "Пожалуйста, введите корректный месяц (01-12).",
                errYear: isKz ? "Туған жылыңызды дұрыс енгізіңіз." : "Пожалуйста, введите корректный год рождения.",
                errDate: isKz ? "Дұрыс күнді енгізіңіз." : "Пожалуйста, введите корректную дату.",
                errAge: isKz ? "Сайтқа кіру үшін жасыңыз 21-ге толуы керек." : "Для дальнейшего входа нужно достичь 21 года."
            };
        }
    },

}

</script>